<app-planting-site-placeholder *ngIf="!sites?.length"></app-planting-site-placeholder>
<div class="row">
    <div class="col-12">
        <div class="map-view">
            <agm-map
                     [zoom]="0"
                     [class.d-none]="!sites || sites.length == 0"
                     [style.height]="'100%'"
                     [fitBounds]="true"
                     [mapTypeControl]="true"
                     [zoomControl]="true"
                     [maxZoom]="20"
                     [mapTypeId]="mapTypeId"
                     (zoomChange)="zooming()"
                     (mapReady)="onMapReady()"
                     [streetViewControl]="false">
                <agm-marker-cluster [styles]="clusterStyles">
                    <agm-marker *ngFor="let site of sites"
                                [latitude]="site.lat"
                                [longitude]="site.lon"
                                [iconUrl]="site | siteMapIcon: activeSite"
                                [agmFitBounds]="true"
                        (markerClick)="showDetail(site)">
                        <agm-snazzy-info-window [closeWhenOthersOpen]="true" *ngIf="isReady"
                                                [border]="false"
                                                [pointer]="false"
                                                [isOpen]="site == activeSite"
                                                (afterClose)="windowClosed(site)"
                            [showCloseButton]="false">
                            <ng-template>
                                <div [routerLink]="['/plantingSite', site.id]" class="map-info-box" style="position: unset">
                                    <div class="map-img"
                                        [class.no-img]="!(site.headerPhoto?.thumbnailUrl || site.headerPhoto?.iconUrl)"
                                        [class.white-bg]="(site.headerPhoto?.thumbnailUrl || site.headerPhoto?.iconUrl)"
                                        style="background-size: cover;"
                                        [appBackgroundUrl]="site.headerPhoto?.iconUrl || site.headerPhoto?.thumbnailUrl">
                                        <span class="year">{{ site.plantingDate | date: 'yyyy' }}</span>
                                    </div>
                                    <div class="map-info">
                                        <h4>{{ site.title || '-' }}</h4>
                                        <span class="tree-amount">{{ (site.totalTrees || 0) | number }} trees</span>
                                        <span [ngClass]="{'not-available': site.availableTrees == 0, 'available' : site.availableTrees > 0}" style="padding-right: 20px">
                                            {{ site.availableTrees == 0 ? 'Fully sponsored' : 'Available:' + ( (site.availableTrees || 0) | number) }}
                                            <i class="icon-arrow-right"></i>
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </agm-snazzy-info-window>
                    </agm-marker>
                </agm-marker-cluster>
                <ng-container *ngFor="let site of sites">
                    <ng-container *ngFor="let area of site.areas">
                        <agm-kml-layer [url]="area.kmlUrl + '?date=' + nowDate" [preserveViewport]="true">
                        </agm-kml-layer>
                        <agm-marker *ngFor="let areaCoordinate of area.kmlAreaProperties" [iconUrl]="labelBar"
                            [label]="{
                                color: 'white',
                                fontFamily: '',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                text: area.year
                            }"
                            [latitude]="areaCoordinate.latitude"
                            [longitude]="areaCoordinate.longitude" [visible]="map.zoom >=19"
                            (markerClick)="navigateToPlanting(site.id, area.id)">
                        </agm-marker>
                    </ng-container>
                </ng-container>
            </agm-map>
        </div>
    </div>
</div>
